import * as _ from "lodash";
import {BaseEditSubView, BaseEditSubViewOptions} from "./_BaseEditView";


export class EditReportsNavView extends BaseEditSubView {

    private template = _.template(require('../../../templates/reports/editReports/editReportsNav.html'));

    constructor(options: BaseEditSubViewOptions) {
        super(_.extend(options, {
            events: {}
        }));
    }

    render () {
        this.$el.html(this.template({
            orgId: this.options.orgId,
            category: this.options.category,
            report: this.options.report,
        }));
        return this;
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/views/reports/editReports/EditReportsNavView.ts